var render = function render(){var _vm=this,_c=_vm._self._c;return _c('spinner-container',{attrs:{"loading":_vm.loading}},[_c('back-btn'),_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"lg":"8"}},[_c('v-card',{staticClass:"card--shadow mb-2"},[_c('v-card-text',[_c('patient-info',{attrs:{"patient":_vm.patient}})],1)],1),_c('clu-form',{attrs:{"patient":_vm.patient}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }